import React, {Component} from 'react';
import { Row } from 'reactstrap';
import NameComponent from './NameComponent';

class IndexComponent extends Component {
    constructor(props){
        super(props)

    }

    render(){
        return(
                <div style = {{flexDirection:'column', display:'flex', alignItems:'center', alignContent:'center', 
                     width:this.props.width}}>
                    <NameComponent textColor = {'#006699'} backgroundColor = {'#f0ebeb'} text = {this.props.index + 1}/>
                </div>
        )
    }
}

export default IndexComponent